import { useRef } from "react";

import { useRect } from "@nens/react/hooks";

type UseTablePaginationProps = {
  page: number;
  numPages: number;
  pagesNextToCurrent: number;
};

export function useTablePagination({
  page,
  numPages,
  pagesNextToCurrent = 2,
}: UseTablePaginationProps) {
  const paginationRef = useRef(null);
  const pageTextRef = useRef(null);
  const pageSizeRef = useRef(null);
  const paginationRect = useRect(paginationRef, true);
  const pageTextRect = useRect(pageTextRef, true);
  const pageSizeRect = useRect(pageSizeRef, true);

  const paginationRight = paginationRect.x + paginationRect.width;
  const wrapPageSize = paginationRight > pageSizeRect.x;
  const hidePageText = !wrapPageSize && paginationRight > pageTextRect.x;

  const firstPageMiddlePart = Math.max(2, page - pagesNextToCurrent);
  const lastPageMiddlePart = Math.min(numPages - 1, page + pagesNextToCurrent);

  const showLeftDots = firstPageMiddlePart > 2;
  const showRightDots = lastPageMiddlePart < numPages - 1;
  const hasMiddlePart = firstPageMiddlePart <= lastPageMiddlePart;

  const middlePart = [];
  if (hasMiddlePart) {
    for (let i = firstPageMiddlePart; i <= lastPageMiddlePart; i++) {
      middlePart.push(i);
    }
  }
  const canClickLeft = page > 1;
  const canClickRight = page < numPages;

  return {
    paginationRef,
    pageTextRef,
    pageSizeRef,
    wrapPageSize,
    hidePageText,
    showLeftDots,
    showRightDots,
    middlePart,
    canClickLeft,
    canClickRight,
  };
}
